module.exports = __webpack_public_path__ + "./Michael2_ec27639af9f8ea0577f7d3fe3cbd3bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Michael2.png
// module id = 571
// module chunks = 0